module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightIt.woff2?1f5154f40f5aac2c883e9d9a386b7397";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightIt.woff2
// module id = 1394
// module chunks = 0